// extracted by mini-css-extract-plugin
module.exports = {"cards":"CardList_cards__2mxpO"};